import * as $ from 'jquery';
import { Notifications } from 'Core/Notifications';

export const InvoiceConfirm = (() => {
    const Selector = {
        FORM : '#invoiceForm',
    }

    $( Selector.FORM ).submit(function( event ) {

        let recaptcha = ($('#g-recaptcha-response').val());

        if ($(Selector.FORM).valid()) {
            if (recaptcha != 'true') {
                Notifications.add('Pole reCaptcha jest nieprawidłowe', 'error');
                event.preventDefault();
            }
            else if(confirm('Czy jesteś pewny wprowadzonych danych?')) {
                return true;
            } else {
                return false;
            }
        }
    });
})();import * as $ from 'jquery';
import { Notifications } from 'Core/Notifications';

export const InvoiceConfirm = (() => {
    const Selector = {
        FORM : '#invoiceForm',
    }

    $( Selector.FORM ).submit(function( event ) {

        let recaptcha = ($('#g-recaptcha-response').val());

        if ($(Selector.FORM).valid()) {
            if (recaptcha != 'true') {
                Notifications.add('Pole reCaptcha jest nieprawidłowe', 'error');
                event.preventDefault();
            }
            else if(confirm('Czy jesteś pewny wprowadzonych danych?')) {
                return true;
            } else {
                return false;
            }
        }
    });
})();